import {Component, OnInit, ViewChild, Input} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {PopupService} from '../../../services/shared/popup.service';
import {CurrencyFormat} from '../../../pipes/currencyFormat.pipe';
import {CarrierService} from '../../../services/carrier.service';
import {ApplicationService} from '../../../services/application.service';
import {PermitService} from '../../../services/permit.service';
import {VehicleService} from '../../../services/vehicle.service';
import {environment} from '../../../../environments/environment';
import {AppVehicleComponent} from '../shared/app-vehicle/app-vehicle.component'
import {PermitTypeDocumentService} from 'app/services/permit-type-document.service';
import {DocumentsServiceService} from 'app/services/documents-service.service';
import {UtilityServiceService} from 'app/services/utility-service.service';
import {ToastrService} from 'ngx-toastr';
import {DatePipe} from '@angular/common';
import {ToastNotificationService} from 'app/shared/toast-notification/toast-notification.service';
import {StepperStage} from '../../../models/StepperStage';
import {StepperContainerComponent} from 'app/shared/stepper/stepper-container/stepper-container.component';


@Component({
    selector: 'app-new-permit-application',
    templateUrl: './new-permit-application.component.html',
    styleUrls: ['./new-permit-application.component.css'],
    providers: [CurrencyFormat, PermitTypeDocumentService]
})
export class NewPermitApplicationComponent implements OnInit {
    @Input('ctrlData') ctrlData: any;

    @Input('isPermitDoc') isPermitDoc: boolean = false;

    @ViewChild(AppVehicleComponent) vehicleComp: AppVehicleComponent;
    isDigitalRoute: any = false;

    dataCntrl: any = {
        carrierID: -1,
        permittypeSelected: false,
        selectedtype: '',
        disableTypes: false,
        processStarted: false,
        currentTab: '',
        formValid: false,
        isViewEditControl: false,
        carrier: {},
        application: {},
        permit: {},
        permittype: {},
        vehicles: [],
        permitTypesDocLinks: []
    };
    StartComplete: boolean;
    VehicleComplete: boolean;
    canSave: boolean;
    canSubmit: boolean;
    pageload: boolean;
    tabload: boolean;

    LensoMassive = 'First Input';

    items = ['1. Permit Info', '2. Vehicles', '3. Routes', '4. Motivation', '5. Uploads', '6. Confirmation'];
    Stages = [
        {stageId: 1, stageName: 'Permit Info'},
        {stageId: 2, stageName: 'Vehicles'},
        {stageId: 3, stageName: 'Routes'},
        {stageId: 4, stageName: 'Motivation '},
        {stageId: 5, stageName: 'Uploads '},
        {stageId: 6, stageName: 'Confirmation '},

    ];

    activeTab = 'permitype';
    disableTabs: boolean = true;
    myreference: '';
    username: any;
    iconCtrl = 1;
    disableBtn: boolean = false;
    isProcess: boolean = false;
    showMenuBtn: boolean = false;
    showPage: boolean;
    listvehicles: any = [];
    permitNum: any = 1;
    routesNum: any = 2;
    uploadsNum: any = 3;
    cnfNum: any = 4;
    timeTableNum: any = 3;
    viewPage: boolean = false;
    duplicateApp: boolean = false;
    amendApp: boolean = false;
    displayIsDuplicateLoader: boolean = false;
    isDuplicated: boolean = false;
    isEditMode: boolean = false;
    changeRouteTimetable: boolean = false;
    processHeader: string = '';
    carrierName: string = '';
    isReplaceVehicle: boolean = false;
    isCorrectPermit: boolean = false;
    carrierNameNew: string = '';
    permitCode: string = '';
    permitNumber: string = '';
    viewAppId: any = null;
    viewPermitCount: any = null;
    permitStatus13: any;

    background1 = 'var(--sapphire)';
    background2 = 'var(--background)';
    background3 = 'var(--background)';
    background4 = 'var(--background)';
    background5 = 'var(--background)';
    background6 = 'var(--background)';
    background7 = 'var(--background)';


    isProgress1 = true;
    isProgress2 = false;
    isProgress3 = false;
    isProgress4 = false;
    isProgress5 = false;
    isProgress6 = false;
    isProgress7 = false;


    isStepper1 = false;
    isStepper2 = false;
    isStepper3 = false;
    isStepper4 = false;
    isStepper5 = false;
    isStepper6 = false;
    isStepper7 = false;


    constructor(private router: Router, private activeRoute: ActivatedRoute, private showModal: PopupService,
                private carrierService: CarrierService, public currformat: CurrencyFormat, private toastService: ToastNotificationService,
                public applicationService: ApplicationService, public permitService: PermitService, private permitTypeDocumentService: PermitTypeDocumentService,
                public vehicleService: VehicleService, public utility: UtilityServiceService, private documentsServiceService: DocumentsServiceService,
                private toastr: ToastrService, private routr: Router, private datePipe: DatePipe, private permitSevc: PermitService) {
    }


    ngOnInit() {

        this.isEditMode = this.router.url.indexOf('edit') > 0 && this.router.url.indexOf('duplicate') < 0;

        this.utility.timetableActive = false;
        this.duplicateApp = this.router.url.indexOf('duplicate') > 0;
        this.amendApp = this.router.url.indexOf('change') > 0;
        this.isReplaceVehicle = this.router.url.indexOf('vehicle') > 0;
        this.isCorrectPermit = this.router.url.indexOf('correction') > 0;
        this.changeRouteTimetable = this.router.url.indexOf('change') > 0;
        this.displayIsDuplicateLoader = this.router.url.indexOf('duplicate') > 0;

        if (this.router.url.indexOf('new') > 0) {
            this.processHeader = 'New Application';
        }//selected-vehicle
        if (this.router.url.indexOf('view') > 0) {
            this.processHeader = 'View Application';
        }
        if (this.router.url.indexOf('edit') > 0) {
            this.activeRoute.params.subscribe((params: Params) => {
                this.dataCntrl.application.id = params['id'];
                const isSelectedVehicle = params['isSelectedVehicle'];
                if (isSelectedVehicle != null || isSelectedVehicle != undefined) {
                    this.processHeader = 'New Application';

                } else {
                    this.processHeader = 'Edit Application';

                }
            });
        }
        if (this.processHeader != null || this.processHeader == '' || this.processHeader != 'View Application') {
            if (localStorage.getItem('aplFlag') != undefined && localStorage.getItem('aplFlag') == 'new') {
                this.processHeader = 'New Application';
            }
        }
        if (this.router.url.indexOf('duplicate') > 0) {
            this.processHeader = 'Duplicate Application';
        }
        if (this.router.url.indexOf('renew') > 0) {
            this.processHeader = 'Renewal Application';
        }
        if (this.router.url.indexOf('change') > 0) {
            this.processHeader = 'Amendment Application';
        }
        if (this.router.url.indexOf('correction') > 0) {
            this.processHeader = 'Permit Correction';
        }
        if (this.router.url.indexOf('vehicle') > 0) {
            this.processHeader = 'Replace Vehicle';
        }
        if (this.router.url.indexOf('completepayment') > 0) {
            this.processHeader = 'Complete Payment';
        }
        if (this.router.url.indexOf('duplicate') > 0 || this.router.url.indexOf('change') > 0) {
            this.activeRoute.params.subscribe((params: Params) => {
                this.applicationService.getById(params['id']).subscribe((data: any) => {
                    this.carrierNameNew = data.carrier.name;
                    this.permitCode = data.permit_type.code;
                    this.permitNumber = data.permits[0].permit_num;
                });
            });
        }

        if (environment.authWebApi.systemData != null && environment.authWebApi.systemData.Configurations != null) {
            this.permitStatus13 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus13').Value;
        }

        if (this.router.url.indexOf('new') > 0 || localStorage.getItem('aplFlag') == 'new') {
            this.activeRoute.params.subscribe((params: Params) => {
                this.dataCntrl.carrierId = params['id'];
                // if(localStorage.getItem('carrierId')!=undefined && localStorage.getItem('carrierId')!=null){
                //   this.dataCntrl.carrierId=localStorage.getItem('carrierId');
                // }
                this.carrierService.getById(this.dataCntrl.carrierId).subscribe((data: any) => {

                    this.carrierNameNew = data.name;
                });
            });
        }
        if (this.router.url.indexOf('edit') < 0 && this.router.url.indexOf('duplicate') < 0) {
            if (environment.authWebApi.userData.Roles.find(p => p.Code != 'ADMIN')) {
                this.activeRoute.params.subscribe((params: Params) => {
                    this.dataCntrl.carrierID = params['id'];
                    this.dataCntrl.status = params['constatus'];
                    //console.log(params['constatus'])
                    //console.log(params['id'])
                    //console.log(this.dataCntrl.carrierID)
                    //console.log(params['type']);
                    if (params['type'] != '') {
                        this.dataCntrl.isSaveAndCon = false;
                    }
                    this.getCarrier();
                    this.carrierService.getById(params['id']).subscribe((data: any) => {
                        this.carrierName = data.name;
                    });
                });
                if (this.dataCntrl.status == 2) {
                    this.dataCntrl.currentTab = '';
                } else {
                    this.dataCntrl.currentTab = 'permitype';
                }

                this.username = environment.authWebApi.userData.User.Username;
            }
        }

        // if (this.router.url.indexOf('edit') > 0) {
        // }
        if (this.router.url.indexOf('edit') > 0 || this.router.url.indexOf('view') > 0) {

            this.activeRoute.params.subscribe((params: Params) => {
                // if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
                this.disableBtn = true;
                this.applicationService.getById(params['id']).subscribe((data: any) => {
                    this.applicationService.dataControlTrackChanges = data;
                    this.dataCntrl.application = data;
                    //   if(localStorage.getItem("permitNum")!=undefined && localStorage.getItem("permitNum")!=null){
                    //     let permitCount:any=parseInt(localStorage.getItem("permitNum"));
                    //     this.viewPermitCount=permitCount;
                    //     if(permitCount>1){
                    //       this.viewAppId=params['id'];
                    //     }else{
                    //       if(data.permit.permit_num!=null && data.permit.permit_num>0){
                    //         this.viewAppId=data.permit.permit_num;
                    //       }else{
                    //         this.viewAppId=params['id'];
                    //       }
                    //     }
                    // }

                    this.dataCntrl.carrierID = data.carrier_id;
                    this.dataCntrl.permit_type_id = data.permit_type_id;
                    this.dataCntrl.permit = data.permit;
                    //   alert(1);
                    //  alert(JSON.stringify(data.permit_type));
                    this.dataCntrl.permittype = data.permit_type;
                    this.isProcess = false;
                    if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
                        //console.log('This is process Admin')
                        this.dataCntrl.currentTab = 'permitype';
                        // this.ctrlData.currentTab = 'permitype';
                        //this.getCarrier();
                        this.showPage = true;
                    }
                    this.carrierName = this.dataCntrl.application.carrier.name;
                });

                //}
            });
        }
        if (this.router.url.indexOf('edit') > 0) {
            this.activeRoute.params.subscribe((params: Params) => {
                if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
                    this.disableBtn = true;
                    //console.log('This is Admin')
                    this.carrierName = this.dataCntrl.application.carrier.name;
                }
            });
        }
        if (this.router.url.indexOf('process') > 0) {
            this.activeRoute.params.subscribe((params: Params) => {
                //  this.ctrlData = this.dataCntrl;
                //console.log(params['id'])
                this.getApp(params['id']);
                //console.log(this.dataCntrl.application)
                if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
                    this.isProcess = true;
                    //console.log('This is process Admin')
                    this.dataCntrl.currentTab = 'permitype';

                    // this.ctrlData.currentTab = 'permitype';
                    //this.getCarrier();
                }
            });

        }
        this.onActive();
        if (this.router.url.indexOf('view') > 0) {
            this.utility.activeTab = 1;
            this.showPage = true;
            this.utility.confirmCtrl = true;
            // if (this.router.url.indexOf('view') > 0) {
            //   this.viewPage = false;
            // //  this.utility.confirmCtrl = false;
            // } else {
            //   this.viewPage = true;
            //   this.utility.confirmCtrl = true;
            // }
        } else {
            this.utility.activeTab = 1;
            this.showPage = true;
            //console.log('Change Key = ', this.utility.changeKey);
        }

        if (this.router.url.indexOf('duplicate') > 0) {
            //console.log(this.dataCntrl);
            setTimeout(() => {
                this.applicationService.setTab(0);
                this.onActive();
                this.displayIsDuplicateLoader = false;
                if (this.router.url.indexOf('edit') > 0 && this.router.url.indexOf('duplicate') > 0 && !this.isDuplicated) {
                    this.applicationService.setTab(4);
                    this.onActive();
                    this.isDuplicated = true;
                }
                this.carrierName = this.dataCntrl.application.carrier.name;

            }, 7000);
            this.activeRoute.params.subscribe((params: Params) => {
                if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
                    this.disableBtn = true;
                    //console.log('This is Admin')
                }
            });
        }
        // if (this.router.url.indexOf('edit') > 0) {
        //   this.activeRoute.params.subscribe((params: Params) => {
        //     this.dataCntrl.application.id = params['id'];
        //     const isSelectedVehicle = params['isSelectedVehicle'];
        //     if(isSelectedVehicle){
        //       //console.log(isSelectedVehicle)

        //       this.utility.activeTab = 2;
        //     }
        //   });

        // }
        if (this.router.url.indexOf('correction') > 0) {
            this.activeRoute.params.subscribe((params: Params) => {
                this.dataCntrl.application.id = params['id'];
                if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
                    this.disableBtn = true;
                    //console.log('This is Admin')
                }
                //this.carrierName = this.dataCntrl.application.carrier.name;
                //console.log(params['id']);
            });
            this.getCarrier();
            setTimeout(() => {
                this.utility.activeTab = 0;

            }, 4000);
        }
        if (this.router.url.indexOf('completepayment') > 0) {
            this.activeRoute.params.subscribe((params: Params) => {
                this.getApp(params['id']);

                this.utility.activeTab = 6;
                this.applicationService.setTab(6);
            });
        }

        if (this.router.url.indexOf('new') > 0) {
            this.utility.dontAllowConfirm = true;
        } else {
            this.activeRoute.params.subscribe((params: Params) => {
                this.applicationService.getById(params['id']).subscribe((result: any) => {
                    this.checkAllowConfirm(result.id, result.permit_type.id);
                });
            });
        }

        this.switchRoutes();
    }


    showMenu(dropdown) {
        this.showMenuBtn = !this.showMenuBtn
    }

    getApp(id) {
        this.applicationService.getById(id).subscribe((data: any) => {
            //console.log(data);
            this.dataCntrl.application = data;
            this.dataCntrl.carrierID = data.carrier_id;
            this.getCarrier();
        })
    }

    getCarrier() {
        this.pageload = true;
        this.carrierService.getById(this.dataCntrl.carrierID).subscribe(result => {
            this.setCarrierData(result);
            this.pageload = false;
        }, error => {
            this.pageload = false;
            //console.log(error);
        });
    }

    setCarrierData(data) {
        data.account_balance = data.account_balance != 0 ? this.currformat.transform(parseFloat(data.account_balance)) : 'R 0.00';
        this.dataCntrl.carrier = data;
        this.dataCntrl.application.carrier_id = data.id;
        this.dataCntrl.application.person_id = data.person_id;
    }

    cancel() {
        this.routr.navigateByUrl('permit/approval')
    }

    approve() {
        this.routr.navigateByUrl('permit/approval/correspondence')
    }

    tabChanged(tab) {
        this.dataCntrl.currentTab = tab;
        this.disableButtons();
        switch (tab) {
            case 'permitype': {
                this.canSave = this.dataCntrl.permittypeSelected ? true : false;
                this.activeTab = tab;
                break;
            }
            case 'vehicle': {
                this.canSave = true;
                this.activeTab = tab;
                break;
            }
            case 'route': {
                this.canSave = true;
                this.activeTab = tab;
                break;
            }
            case 'motivation': {
                this.canSave = true;
                this.activeTab = tab;
                break;
            }
            case 'uploads': {
                this.canSave = true;
                this.activeTab = tab;
                break;
            }
        }
    }

    disableButtons() {
        this.canSave = false;
        this.canSubmit = false;
    }

    onStart() {
        this.saveApplication();
        this.canSave = true;
        this.dataCntrl.processStarted = true;
        this.disableTabs = this.dataCntrl.permittypeSelected ? false : true;
        this.activeTab = 'vehicle';
        this.dataCntrl.currentTab = 'vehicle';
    }

    onCancel() {
        if (this.dataCntrl.processStarted == true && this.dataCntrl.application.id == undefined) {
            this.showModal.showConfirm('Cancel Application', 'Are you sure you want to cancel?', `Your application has not been saved. If you continue to cancel without saving, you will loose all your data.`, 'Yes', 'No')
                .subscribe((isConfirmed) => {
                    if (isConfirmed) {
                        this.router.navigateByUrl(`/carrier/permit/application/${this.dataCntrl.carrierID}`);
                    } else {
                        return;
                    }
                });
        } else {
            this.router.navigateByUrl(`/carrier/permit/application/${this.dataCntrl.carrierID}`);
        }
    }

    onSave() {
        switch (this.dataCntrl.currentTab) {
            case 'permitype': {
                if (this.dataCntrl.application.id == undefined) {

                    this.saveApplication();
                } else {
                    this.showModal.showAlert('Save Application', 'Application saved successfully');
                }
                break;
            }
            case 'vehicle': {
                this.saveVehicles();
                break;
            }
            case 'route': {
                this.saveRoute();
                break;
            }
            case 'motivation': {
                this.saveMotivation();
                break;
            }
            case 'uploads': {
                if (this.dataCntrl.application.id == undefined) {
                    this.saveApplication();
                } else {
                    this.showModal.showAlert('Save Application', 'Application saved successfully');
                }
                break;
            }
        }
    }

    saveApplication() {
        this.tabload = true;
        this.dataCntrl.application.date_modified = this.dataCntrl.application.date_created = new Date();
        this.dataCntrl.application.user_modified = this.dataCntrl.application.user_created = this.username;


        this.applicationService.postApplication(this.dataCntrl.application)
            .subscribe((result: any) => {
                    this.dataCntrl.application = result;
                    if (this.dataCntrl.permit.length > 0) {
                        this.dataCntrl.permit.forEach(permit => {
                            permit.permit_type_id = result.permit_type_id;
                            permit.application_id = result.id;
                            //alert('savedApp');

                            this.savePermit(permit);
                        });
                    }
                },
                error => {
                    this.tabload = false;
                    this.showModal.showError('Save Application', 'Failed to save application. If the problem persist, please contact system administrator.', error);

                    return;
                });
    }

    savePermit(permit) {
        permit.date_modified = permit.date_created = new Date();
        permit.user_modified = permit.user_created = this.username;
        permit.permit_fee = this.dataCntrl.permittype.current_fee == null ? 0 : this.dataCntrl.permittype.current_fee;
        permit.application_fee = this.dataCntrl.permittype.current_application_fee == null ? 0 : this.dataCntrl.permittype.current_application_fee;
        this.permitService.postPermit(permit)
            .subscribe((result: any) => {
                    var index = this.dataCntrl.permit.findIndex(x => x.id == result.id);
                    this.dataCntrl.permits[index] = result;
                    // this.dataCntrl.permit = result;
                    this.tabload = false;
                },
                error => {
                    this.tabload = false
                    this.showModal.showError('Save Application', 'Failed to save application. If the problem persist, please contact system administrator.', error);
                    return;
                });
    }

    onBack() {
        this.router.navigateByUrl('permit/approval');
    }


    saveVehicles() {
        this.tabload = true;
        this.dataCntrl.vehicles.forEach(element => {
            //element.permit_id = this.dataCntrl.permit.id;
            //alert(element.permit_id);
            element.date_modified = element.date_created = new Date();
            element.user_modified = element.user_created = this.username;
        });

        if (this.dataCntrl.application.id == undefined) {
            this.saveApplication();
        } else {
            this.vehicleService.postVehicle(this.dataCntrl.vehicles)
                .subscribe(result => {
                        this.dataCntrl.vehicles = result;
                        this.updateVehiclelist(result);
                        ///this.toastr.success('Saved Step 1 Successfully','Step 1');
                    },
                    error => {
                        this.tabload = false;
                        this.showModal.showError('Save Application', 'Failed to save application. If the problem persist, please contact system administrator.', error);
                        return;
                    });
        }
    }


    updateVehiclelist(data) {
        this.vehicleComp.listvehicles = data;
        this.tabload = false;
        //this.nextFrame();
    }

    saveRoute() {

        this.tabload = true;
        if (this.dataCntrl.application.id == undefined) {
            this.saveApplication();
        } else {
            this.applicationService.putApplication(this.dataCntrl.application)
                .subscribe(result => {
                        this.dataCntrl.application = result;
                        this.tabload = false;
                        this.showModal.showAlert('Save Application', 'Route saved successfully');
                    },
                    error => {
                        this.tabload = false;
                        this.showModal.showError('Save Application', 'Failed to save application. If the problem persist, please contact system administrator.', error);
                        return;
                    });
        }
    }

    saveMotivation() {
        this.tabload = true;
        if (this.dataCntrl.application.id == undefined) {
            this.saveApplication();
        } else {
            this.applicationService.putApplication(this.dataCntrl.application)
                .subscribe(result => {
                        this.dataCntrl.application = result;
                        this.tabload = false;
                        this.showModal.showAlert('Save Application', 'Motivation saved successfully');
                    },
                    error => {
                        //console.log(error)
                        this.tabload = false;
                        this.showModal.showError('Save Application', 'Failed to save application. If the problem persist, please contact system administrator.', error);
                        return;
                    });
        }
    }

    onActive() {
        //this.iconCtrl = key;
        //alert(this.utility.activeTab );
        this.applicationService.getTab().subscribe(x => {
            //console.log(x);
            // alert(x);
            if (x >= 0) {
                this.utility.activeTab = x;

                if (this.utility.activeTab == 2 && this.isReplaceVehicle) {

                    this.dataCntrl.application.permit_type_id = 16;
                }
            }

        })
    }

    onActive1(tabNum) {

        if (this.router.url.indexOf('view') > 0) {
            this.applicationService.setTab(tabNum);
            this.onActive();


        }
        if (tabNum == 1) {
            if (this.router.url.indexOf('edit') > 0) {
                if (this.dataCntrl.application.id != null) {
                    this.router.navigate(['carrier/permit/application/edit/', this.dataCntrl.application.id]);
                }
            }
        }


        if (Object.keys(this.dataCntrl.permittype).length > 0 && this.router.url.indexOf('view') < 0) {

            if (this.dataCntrl.application.id != null) {
                //console.log(this.dataCntrl.application.vehicle[0]);
                if ((this.dataCntrl.application.vehicle.length == 0 || (this.dataCntrl.application.vehicle.length == 1 && this.dataCntrl.application.vehicle[0] == undefined)) && tabNum > 2 &&
                    (this.dataCntrl.permittype.temp_long_ind == 1 || (this.dataCntrl.permittype.temp_long_ind == 2 && this.dataCntrl.permittype.freight_passenger_ind == 1) ||
                        (this.dataCntrl.permittype.temp_long_ind == 2 && this.dataCntrl.permittype.freight_passenger_ind == 2 && this.dataCntrl.application.status_id == this.permitStatus13))) {
                    this.applicationService.setTab(2);
                    this.onActive();
                    this.jumpToVehicle();
                    return false;
                } else if (this.dataCntrl.application.route_id == null && tabNum > 3) {
                    this.applicationService.setTab(3);
                    this.onActive();
                    return false;
                } else if (this.dataCntrl.application.motivation_detail == '' && tabNum > 4) {
                    this.applicationService.setTab(4);
                    this.onActive();
                    return false;
                } else if (this.utility.timetableActive && this.router.url.indexOf('view') < 0) {
                    if (this.dataCntrl.timeTableList != undefined && this.dataCntrl.timeTableList.length == 0 && tabNum > 5) {
                        this.applicationService.setTab(5);
                        this.onActive();
                        return false;
                    } else if (this.dataCntrl.uploadedDocs != undefined && this.dataCntrl.uploadedDocs.length == 0 && tabNum > 6) {
                        this.applicationService.setTab(6);
                        this.onActive();
                        return false;
                    }
                } else if (this.router.url.indexOf('view') < 0 && this.dataCntrl.uploadedDocs != undefined && this.dataCntrl.uploadedDocs.length == 0 && tabNum > 5) {
                    this.applicationService.setTab(5);
                    this.onActive();
                    return false;
                }
                this.applicationService.setTab(tabNum);
                this.onActive();
            } else {
                this.toastService.error('Please save and continue', 'Permit Type');
            }

        } else {
            if (tabNum != 1 && this.router.url.indexOf('view') < 0) {
                if (tabNum > 1 && Object.keys(this.dataCntrl.permittype).length == 0) {
                    this.toastService.error('Please select your Permit Type ', 'Permit Type');
                    this.applicationService.setTab(1);
                    this.onActive();
                    return false;
                }
            }

        }

    }

    nextFrame = () => {
        this.utility.activeTab = 3;
        this.utility.confirmCtrl = true;
        this.iconCtrl = 3;
    }

    getSavedVehicleByPermit(id) {
        this.pageload = true;
        this.listvehicles = [];

        this.permitSevc.getAppPer().subscribe((data: any) => {

            let permits: any = '';
            permits = data.filter(i => i.application_id == this.dataCntrl.application.id);
            this.vehicleService.getAllVehicles().subscribe((x: any) => {
                if (permits.length > 0) {
                    for (let p = 0; p < permits.length; p++) {
                        //console.log(permits[p].id)

                        //console.log(x.filter(i => i.permit_id == permits[p].id))
                        let allVeh = x.filter(i => i.permit_id == permits[p].id);

                        if (allVeh.length > 0) {
                            for (let v = 0; v < allVeh.length; v++) {

                                this.vehicleService.getAllVe(allVeh[v].permit_id).subscribe((vehicles: any) => {
                                    //console.log(vehicles)
                                    let object = {
                                        id: vehicles.id,
                                        vehicle_type_id: vehicles.vehicle_type_id,
                                        vehicle_make_id: vehicles.vehicle_make_id,
                                        vehicle_make: vehicles.vehicle_make,
                                        vehicle_type: vehicles.vehicle_type,
                                        is_current: false,
                                        registration_number: vehicles.registration_number,
                                        // seating_capacity:vehicles.seating_capacity,
                                        number_passengers: vehicles.number_passengers,
                                        gvn: vehicles.gvn,
                                        vin: vehicles.vin,
                                        date_license_expiry: this.datePipe.transform(vehicles.date_license_expiry, 'dd/MM/yyyy'),
                                        start_date: this.datePipe.transform(vehicles.start_date, 'dd/MM/yyyy'),
                                        editMode: false
                                    }
                                    //console.log(object)
                                    //   if(this.listvehicles.length === data.vehicle.length){
                                    // //console.log('Its 0')
                                    //  this.listvehicles = this.dataCntrl.vehicles ;
                                    //  this.pageload = false;

                                    // return;
                                    //   }
                                    this.listvehicles.push(object);
                                    this.pageload = false;

                                    //console.log(this.listvehicles)


                                    this.listvehicles.sort(function (a, b) {
                                        if (a.id < b.id) {
                                            return -1;
                                        }
                                        if (a.id > b.id) {
                                            return 1;
                                        }
                                        return 0;
                                    })
                                    //console.log(this.dataCntrl.vehicles);
                                }, error => {
                                    this.pageload = false;
                                    //console.log(this.listvehicles);
                                    this.dataCntrl.vehicles = this.listvehicles;
                                })

                            }
                        }

                        this.pageload = false;
                        this.dataCntrl.vehicles = this.listvehicles;


                    }
                } else {
                    this.pageload = false;
                    //console.log(this.listvehicles);
                    this.dataCntrl.vehicles = this.listvehicles;


                }

                // this.newListvehicles.push(x)
                //  //console.log(this.newListvehicles)
                //  this.dataCntrl.vehicles = this.newListvehicles
                // //  this.listvehicles = this.dataCntrl.vehicles;


            }, error => {
                this.pageload = false;
                //console.log(this.listvehicles);
                this.dataCntrl.vehicles = this.listvehicles;
            })


        }, error => {
            this.pageload = false;
            //console.log(this.listvehicles);
            this.dataCntrl.vehicles = this.listvehicles;
        })
    }

    orderTabSequence = (isPlus, seq) => {
        return (isPlus) ? seq : seq;
    }

    checkAllowConfirm(applicationId, permitTypeId) {
        this.displayIsDuplicateLoader = true;
        if (this.router.url.indexOf('view') > 0) {
            this.utility.dontAllowConfirm = false;
        } else {
            this.permitTypeDocumentService.getLinkedAndUnlinkedDoctypes(permitTypeId).subscribe(permitTypeDocs => {
                    let permitTypeDocList = permitTypeDocs['PermitLinked'].filter(status => status.is_mandatory == true);
                    this.documentsServiceService.getPermitById(applicationId).subscribe((applicationDocs: any) => {
                            let applicationDocList = applicationDocs;
                            if (applicationDocList.length >= permitTypeDocList.length) {
                                let docFound: string = '';
                                let count: number = 0;

                                // determine if all mandatory documents have been uploaded
                                permitTypeDocList.forEach(doc => {
                                    docFound = applicationDocList.find(appDoc => appDoc.code === doc.code)
                                    if (docFound != undefined && docFound != null) {
                                        count++;
                                    }
                                });

                                //console.log(count);

                                // if count equals number of mandatory documents, all mandatory documents have been uploaded
                                if (count == permitTypeDocList.length) {
                                    this.utility.dontAllowConfirm = false;
                                } else {
                                    this.utility.dontAllowConfirm = true;
                                }
                            } else {
                                this.utility.dontAllowConfirm = true;
                            }
                        }
                        , error => {
                            if (error.status != 404) {
                                this.toastService.error(`Error during permit application. The server error response code is Error ${error.status} : ${error.statusText}`, `ERROR : Permit Application`);
                                // this.toastr.error(error.status + " - " + error.statusText, 'SYSTEM ERROR! (new-permit-application)');
                            } else {
                                if (permitTypeDocList.length == 0) {
                                    this.utility.dontAllowConfirm = false;
                                } else {
                                    this.utility.dontAllowConfirm = true;
                                }

                            }
                        });
                }
                , error => {
                    if (error.status != 404) {
                        this.toastService.error(`Error during permit application. The server error response code is Error ${error.status} : ${error.statusText}`, `ERROR : Permit Application`);
                        // this.toastr.error(error.status + " - " + error.statusText, 'SYSTEM ERROR! (new-permit-application)');
                    } else {
                        this.utility.dontAllowConfirm = true;
                    }
                });
        }
        this.displayIsDuplicateLoader = false;
    }


    addItem(newItem: string) {
        console.log(newItem);
        this.items.push(newItem);
    }

    jumpToPermit() {
        localStorage.setItem('jumpToVehicle', 'false');
        if (this.router.url.indexOf('edit') != -1 || this.router.url.indexOf('view') != -1) {
            setTimeout(() => {
                if (this.isStepper7 && this.utility.timetableActive) {
                    document.getElementById('con1-stepper-prev').click();
                }
                if (this.isStepper6 && !this.utility.timetableActive) {
                    document.getElementById('con-stepper-prev').click();
                }

            }, 100);
            setTimeout(() => {
                if (this.isStepper6 && this.utility.timetableActive) {
                    document.getElementById('uploads1-stepper-prev').click();
                }
                if (this.isStepper5 && !this.utility.timetableActive) {
                    document.getElementById('uploads-stepper-prev').click();
                }
            }, 100);
            setTimeout(() => {
                if (this.isStepper5 && this.utility.timetableActive) {
                    document.getElementById('timetable-stepper-prev').click();
                }
            }, 100);
            setTimeout(() => {
                document.getElementById('motivation-stepper-prev').click();
            }, 100);
            setTimeout(() => {
                document.getElementById('route-stepper-prev').click();
            }, 100);
            setTimeout(() => {
                document.getElementById('vehicle-stepper-prev').click();
            }, 100);
        }
    }

    jumpToVehicle() {
        this.isStepper1 = false
        this.isStepper2 = true
        this.isStepper3 = false
        this.isStepper4 = false
        this.isStepper5 = false
        this.isStepper6 = false
        this.isStepper7 = false
        //Progress
        this.isProgress1 = false
        this.isProgress2 = true
        this.isProgress3 = false
        this.isProgress4 = false
        this.isProgress5 = false
        this.isProgress6 = false
        this.isProgress7 = false
        this.stepTwoActiveTab();

    }

    jumpToDocuments() {
        this.isStepper1 = false
        this.isStepper2 = false
        this.isStepper3 = false
        this.isStepper4 = false
        if (!this.utility.timetableActive) {
            this.isStepper5 = true
        } else {
            this.isStepper5 = false
            this.isStepper6 = true
            this.isStepper7 = false
        }

        //Progress
        this.isProgress1 = false
        this.isProgress2 = true
        this.isProgress3 = false
        this.isProgress4 = false
        if (!this.utility.timetableActive) {
            this.isProgress5 = true
            this.stepFiveActiveTab();
        } else {
            this.isProgress5 = false
            this.isProgress6 = true
            this.isProgress7 = false
            this.stepSixActiveTab();
        }


    }

    jumpToSummary() {
        this.isStepper1 = false
        this.isStepper2 = false
        this.isStepper3 = false
        this.isStepper4 = false
        if (!this.utility.timetableActive) {
            this.isStepper5 = false
        } else {
            this.isStepper5 = false
            this.isStepper6 = false
            this.isStepper7 = false
        }
        if (!this.utility.timetableActive) {
            this.isStepper6 = true
        } else {
            this.isStepper6 = false
            this.isStepper7 = true;
        }

        //Progress
        this.isProgress1 = false
        this.isProgress2 = false
        this.isProgress3 = false
        this.isProgress4 = false
        if (!this.utility.timetableActive) {
            this.isProgress5 = true
            this.stepFiveActiveTab();
        } else {
            this.isProgress5 = false
            this.isProgress6 = false
            this.isProgress7 = false
            this.stepSixActiveTab();
        }
        if (!this.utility.timetableActive) {
            this.isProgress6 = true
            this.stepSixActiveTab();
        } else {
            this.isProgress6 = false
            this.isProgress7 = true;
        }


    }

    next(event: any) {
        switch (event) {
            case 1:
                this.hideStepOneFromBeingActive();
                this.stepTwoActiveTab();
                localStorage.setItem('jumpToVehicle', 'true');
                break;
            case 2:
                console.log('Step 2 Stepper', event);
                localStorage.setItem('jumpToVehicle', 'false');
                this.hideStepTwoFromBeingActive();
                this.stepThreeActiveTab();
                break;
            case 3:
                localStorage.setItem('jumpToVehicle', 'false');
                this.hideStep3FromBeingActive();
                this.step4ActiveTab();
                break;
            case 4:
                localStorage.setItem('jumpToVehicle', 'false');
                this.hideStep4FromBeingActive();
                this.step5ActiveTab();
                break;
            case 5:
                localStorage.setItem('jumpToVehicle', 'false');
                // this.hideStep5FromBeingActive();
                // this.step6ActiveTab();
                this.jumpToSummary();
                break;
            case 6:
                localStorage.setItem('jumpToVehicle', 'false');
                this.hideStep6FromBeingActive();
                this.step7ActiveTab();
                break;
            default:
            //this.done();
        }

    }

    // next(event: any) {
    //     switch (event) {
    //         case 1:
    //
    //             break;
    //         case 2:
    //             localStorage.setItem('jumpToVehicle', 'false');
    //             this.hideStepTwoFromBeingActive();
    //             this.stepThreeActiveTab();
    //             break;
    //         case 3:
    //
    //             break;
    //         case 4:
    //
    //             break;
    //         case 5:
    //             this.jumpToSummary();
    //
    //             break;
    //         case 6:
    //
    //             break;
    //         default:
    //         //this.done();
    //     }
    //
    // }

    previous(event: any) {
        switch (event) {
            case 2:
                this.prevHideTwo();
                break;
            case 3:
                this.prevHideThree();
                break;
            case 4:
                console.log('I was clicked case 4');
                this.prevHide4();
                break;
            case 5:
                this.prevHide5();
                break;
            case 6:
                this.prevHide6();
                break
            default:
                this.prevHide7();
        }

    }
    stepTwoActiveTab() {
        const stepTwo = <HTMLElement>document.getElementsByClassName('step-two')[0];
        stepTwo.style.fontSize = '20px';
        stepTwo.style.fontWeight = 'bold';
    }
    stepThreeActiveTab() {
        const stepTwo = <HTMLElement>document.getElementsByClassName('step-three')[0];
        stepTwo.style.fontSize = '20px';
        stepTwo.style.fontWeight = 'bold';
    }
    step4ActiveTab() {
        const stepTwo = <HTMLElement>document.getElementsByClassName('step-four')[0];
        stepTwo.style.fontSize = '20px';
        stepTwo.style.fontWeight = 'bold';
    }
    step5ActiveTab() {
        const stepTwo = <HTMLElement>document.getElementsByClassName('step-five')[0];
        stepTwo.style.fontSize = '20px';
        stepTwo.style.fontWeight = 'bold';
    }
    step6ActiveTab() {
        const stepTwo = <HTMLElement>document.getElementsByClassName('step-six')[0];
        stepTwo.style.fontSize = '20px';
        stepTwo.style.fontWeight = 'bold';
    }
    step7ActiveTab() {
        const stepTwo = <HTMLElement>document.getElementsByClassName('step-seven')[0];
        stepTwo.style.fontSize = '20px';
        stepTwo.style.fontWeight = 'bold';
    }
    hideStepOneFromBeingActive() {
        this.isStepper2 = true;
        this.isProgress1 = false;
        this.background2 = 'var(--sapphire)';
        const element = <HTMLElement>document.getElementsByClassName('step-one')[0];
        element.style.fontSize = '16px';
        element.style.fontWeight = 'lighter';
    }
    hideStepTwoFromBeingActive() {
        this.isStepper3 = true;
        this.isStepper2 = false; // Hide tab 2
        this.isProgress2 = true;
        this.background3 = 'var(--sapphire)';
        const element = <HTMLElement>document.getElementsByClassName('step-two')[0];
        element.style.fontSize = '16px';
        element.style.fontWeight = 'lighter';
    }
    hideStep3FromBeingActive() {
        this.isStepper4 = true;
        this.isStepper3 = false; // Hide tab 3
        this.isProgress3 = true;
        this.background4 = 'var(--sapphire)';
        const element = <HTMLElement>document.getElementsByClassName('step-three')[0];
        element.style.fontSize = '16px';
        element.style.fontWeight = 'lighter';
    }
    hideStep4FromBeingActive() {
        this.isStepper5 = true;
        //this.isStepper2 = false;
        this.isStepper4 = false; // Hide tab 3
        this.isProgress4 = true;
        this.isStepper1 = false;
        this.background5 = 'var(--sapphire)';
        const element = <HTMLElement>document.getElementsByClassName('step-four')[0];
        element.style.fontSize = '16px';
        element.style.fontWeight = 'lighter';
    }
    hideStep5FromBeingActive() {
        this.isStepper6 = true;
        this.isStepper5 = false; // Hide tab 3
        this.isProgress5 = true;
        this.background6 = 'var(--sapphire)';
        const element = <HTMLElement>document.getElementsByClassName('step-five')[0];
        element.style.fontSize = '16px';
        element.style.fontWeight = 'lighter';
    }
    hideStep6FromBeingActive() {
        this.isStepper7 = true;
        this.isStepper6 = false; // Hide tab 3
        this.isProgress6 = true;
        this.background7 = 'var(--sapphire)';
        const element = <HTMLElement>document.getElementsByClassName('step-six')[0];
        element.style.fontSize = '16px';
        element.style.fontWeight = 'lighter';
    }
    done() {
        this.isProgress6 = true;
        const element = <HTMLElement>document.getElementsByClassName('step-six')[0];
        element.style.fontSize = '16px';
        element.style.fontWeight = 'lighter';
    }
    prevHideTwo() {
        this.background3 = 'var(--sapphire)';
        const element = <HTMLElement>document.getElementsByClassName('step-two')[0];
        element.style.fontSize = '16px';
        element.style.fontWeight = 'lighter';
        this.isProgress1 = true;
        this.isProgress2 = false;
        this.isStepper2 = false;
        this.stepOneIsActiveAgain();
    }
    stepOneIsActiveAgain() {
        const element = <HTMLElement>document.getElementsByClassName('step-one')[0];
        element.style.fontSize = '20px';
        element.style.fontWeight = 'bold';
    }
    prevHideThree() {
        this.background2 = 'var(--sapphire)';
        const stepTwo = <HTMLElement>document.getElementsByClassName('step-three')[0];
        stepTwo.style.fontSize = '16px';
        stepTwo.style.fontWeight = 'lighter';
        this.isStepper2 = true;
        this.isStepper3 = false;
        this.isProgress3 = false;
        this.stepTwoActiveTab();
    }
    prevHide4() {
        this.background3 = 'var(--sapphire)';
        const stepTwo = <HTMLElement>document.getElementsByClassName('step-four')[0];
        stepTwo.style.fontSize = '16px';
        stepTwo.style.fontWeight = 'lighter';
        this.isStepper3 = true;
        this.isStepper4 = false;
        this.isProgress4 = false;
        this.stepThreeActiveTab();
    }
    prevHide5() {
        this.background4 = 'var(--sapphire)';

        const stepTwo = <HTMLElement>document.getElementsByClassName('step-five')[0];
        stepTwo.style.fontSize = '16px';
        stepTwo.style.fontWeight = 'lighter';
        this.isStepper4 = true;
        this.isStepper5 = false;
        this.isProgress5 = false;
        this.step4ActiveTab();
    }
    prevHide6() {
        this.background5 = 'var(--sapphire)';
        const stepTwo = <HTMLElement>document.getElementsByClassName('step-six')[0];
        stepTwo.style.fontSize = '16px';
        stepTwo.style.fontWeight = 'lighter';
        this.isStepper5 = true;
        this.isStepper6 = false;
        this.isProgress6 = false;
        this.step5ActiveTab();
    }
    prevHide7() {
        this.background6 = 'var(--sapphire)';
        const stepTwo = <HTMLElement>document.getElementsByClassName('step-seven')[0];
        stepTwo.style.fontSize = '16px';
        stepTwo.style.fontWeight = 'lighter';
        this.isStepper6 = true;
        this.isStepper7 = false;
        this.isProgress7 = false;
        this.step6ActiveTab();
    }


    stepSixActiveTab() {
        const stepTwo = <HTMLElement>document.getElementsByClassName('step-six')[0];
        stepTwo.style.fontSize = '20px';
        stepTwo.style.fontWeight = 'bold';
        this.background6 = 'var(--sapphire)';
        const element = <HTMLElement>document.getElementsByClassName('step-five')[0];
        element.style.fontSize = '16px';
        element.style.fontWeight = 'lighter';
    }

    stepSevenActiveTab() {
        const stepTwo = <HTMLElement>document.getElementsByClassName('step-seven')[0];
        stepTwo.style.fontSize = '20px';
        stepTwo.style.fontWeight = 'bold';
        this.background7 = 'var(--sapphire)';
        const element = <HTMLElement>document.getElementsByClassName('step-six')[0];
        element.style.fontSize = '16px';
        element.style.fontWeight = 'lighter';
    }

    stepFourActiveTab() {
        const stepTwo = <HTMLElement>document.getElementsByClassName('step-four')[0];
        stepTwo.style.fontSize = '20px';
        stepTwo.style.fontWeight = 'bold';
        this.background4 = 'var(--sapphire)';
        const element = <HTMLElement>document.getElementsByClassName('step-three')[0];
        element.style.fontSize = '16px';
        element.style.fontWeight = 'lighter';
    }

    stepFiveActiveTab() {
        const stepTwo = <HTMLElement>document.getElementsByClassName('step-five')[0];
        stepTwo.style.fontSize = '20px';
        stepTwo.style.fontWeight = 'bold';
        this.background5 = 'var(--sapphire)';
        const element = <HTMLElement>document.getElementsByClassName('step-four')[0];
        element.style.fontSize = '16px';
        element.style.fontWeight = 'lighter';
    }


    jumpToRoutes() {
        console.log('Clicked Vehicle', 'The Vehicle')
        localStorage.setItem('jumpToVehicle', 'false');
        if (this.router.url.indexOf('edit') != -1 || this.router.url.indexOf('view') != -1 || this.router.url.indexOf('change') != -1) {

            setTimeout(() => {
                document.getElementById('permit-stepper').click();
            }, 100);

            setTimeout(() => {
                ///  document.getElementById('vehicle-stepper-next').click();
            }, 100);

            setTimeout(() => {
                document.getElementById('route-stepper-next').click();
            }, 100);

            setTimeout(() => {
                document.getElementById('motivation-stepper-next').click();
            }, 100);
            setTimeout(() => {
                if (this.isStepper5 && this.utility.timetableActive) {
                    document.getElementById('timetable-stepper-next').click();
                }
            }, 100);
            setTimeout(() => {
                if (this.isStepper5 && !this.utility.timetableActive) {
                    document.getElementById('uploads-stepper-next').click();
                }
            }, 100);
            setTimeout(() => {
                if (this.isStepper6 && this.utility.timetableActive) {
                    document.getElementById('uploads1-stepper-next').click();
                }
            }, 100);
            setTimeout(() => {
                if (this.isStepper6 && !this.utility.timetableActive) {
                    document.getElementById('con-stepper-prev').click();
                }
            }, 100);
            setTimeout(() => {
                if (this.isStepper7 && this.utility.timetableActive) {
                    document.getElementById('con1-stepper-prev').click();
                }
            }, 100);
            setTimeout(() => {
                if (this.isStepper6 && this.utility.timetableActive) {
                    document.getElementById('uploads1-stepper-prev').click();
                }
            }, 100);
            setTimeout(() => {
                if (this.isStepper5 && !this.utility.timetableActive) {
                    document.getElementById('uploads-stepper-prev').click();
                }
            }, 100);
            setTimeout(() => {
                if (this.isStepper5 && this.utility.timetableActive) {
                    document.getElementById('timetable-stepper-prev').click();
                }
            }, 100);
            setTimeout(() => {
                document.getElementById('motivation-stepper-prev').click();
            }, 100);


        }
    }

    jumpToMotivation() {
        this.stepFourActiveTab();
        this.isStepper1 = false
        this.isStepper2 = false
        this.isStepper3 = false
        this.isStepper4 = true
        if (!this.utility.timetableActive) {
            this.isStepper5 = false;
        } else {
            this.isStepper5 = false;
            this.isStepper6 = false;
            this.isStepper7 = false;
        }

        //Progress
        this.isProgress1 = false
        this.isProgress2 = false;
        this.isProgress3 = false
        this.isProgress4 = true
        if (!this.utility.timetableActive) {
            this.isProgress5 = false
        } else {
            this.isProgress5 = false
            this.isProgress6 = false
            this.isProgress7 = false
        }


    }

    jumpToTimetables() {
        localStorage.setItem('jumpToVehicle', 'false');
        if (this.router.url.indexOf('edit') != -1 || this.router.url.indexOf('view') != -1) {
            setTimeout(() => {
                document.getElementById('permit-stepper').click();
            }, 100);
            setTimeout(() => {
                document.getElementById('vehicle-stepper-next').click();
            }, 100);
            setTimeout(() => {
                document.getElementById('route-stepper-next').click();
            }, 100);
            setTimeout(() => {
                document.getElementById('motivation-stepper-next').click();
            }, 100);
            setTimeout(() => {
                if (this.isStepper5 && this.utility.timetableActive) {
                    document.getElementById('timetable-stepper-next').click();
                }
            }, 100);
            setTimeout(() => {
                if (this.isStepper5 && !this.utility.timetableActive) {
                    document.getElementById('uploads-stepper-next').click();
                }
            }, 100);
            setTimeout(() => {
                if (this.isStepper6 && this.utility.timetableActive) {
                    document.getElementById('uploads1-stepper-next').click();
                }
            }, 100);
            setTimeout(() => {
                if (this.isStepper6 && !this.utility.timetableActive) {
                    document.getElementById('con-stepper-prev').click();
                }
            }, 100);
            setTimeout(() => {
                if (this.isStepper7 && this.utility.timetableActive) {
                    document.getElementById('con1-stepper-prev').click();
                }
            }, 100);
            setTimeout(() => {
                if (this.isStepper6 && this.utility.timetableActive) {
                    document.getElementById('uploads1-stepper-prev').click();
                }
            }, 100);
            setTimeout(() => {
                if (this.isStepper5 && !this.utility.timetableActive) {
                    document.getElementById('uploads-stepper-prev').click();
                }
            }, 100);


        }
    }

    jumpToUploads() {
        localStorage.setItem('jumpToVehicle', 'false');
        if (this.router.url.indexOf('edit') != -1 || this.router.url.indexOf('view') != -1) {
            setTimeout(() => {
                document.getElementById('permit-stepper').click();
            }, 100);
            setTimeout(() => {
                document.getElementById('vehicle-stepper-next').click();
            }, 100);
            setTimeout(() => {
                document.getElementById('route-stepper-next').click();
            }, 100);
            setTimeout(() => {
                document.getElementById('motivation-stepper-next').click();
            }, 100);
            setTimeout(() => {
                if (this.isStepper5 && this.utility.timetableActive) {
                    document.getElementById('timetable-stepper-next').click();
                }
            }, 100);
            setTimeout(() => {
                if (this.isStepper5 && !this.utility.timetableActive) {
                    document.getElementById('uploads-stepper-next').click();
                }
            }, 100);
            setTimeout(() => {
                if (this.isStepper6 && this.utility.timetableActive) {
                    document.getElementById('uploads1-stepper-next').click();
                }
            }, 100);
            setTimeout(() => {
                if (this.isStepper6 && !this.utility.timetableActive) {
                    document.getElementById('con-stepper-prev').click();
                }
            }, 100);
            setTimeout(() => {
                if (this.isStepper7 && this.utility.timetableActive) {
                    document.getElementById('con1-stepper-prev').click();
                }
            }, 100);


        }
    }

    jumpToReview() {
        localStorage.setItem('jumpToVehicle', 'false');
        if (this.router.url.indexOf('edit') != -1 || this.router.url.indexOf('view') != -1) {
            setTimeout(() => {
                document.getElementById('permit-stepper').click();
            }, 100);
            setTimeout(() => {
                document.getElementById('vehicle-stepper-next').click();
            }, 100);
            setTimeout(() => {
                document.getElementById('route-stepper-next').click();
            }, 100);
            setTimeout(() => {
                document.getElementById('motivation-stepper-next').click();
            }, 100);
            setTimeout(() => {
                if (this.isStepper5 && this.utility.timetableActive) {
                    document.getElementById('timetable-stepper-next').click();
                }
            }, 100);
            setTimeout(() => {
                if (this.isStepper5 && !this.utility.timetableActive) {
                    document.getElementById('uploads-stepper-next').click();
                }
            }, 100);
            setTimeout(() => {
                if (this.isStepper6 && this.utility.timetableActive) {
                    document.getElementById('uploads1-stepper-next').click();
                }
            }, 100);


        }
    }

    switchRoutes(){
        let routeType = localStorage.getItem('routeType');
        if(routeType == 'DigitalRoute'){}
        {
            this.isDigitalRoute = true;
        }
        if(routeType == 'TextRoute'){
            this.isDigitalRoute = false;
        }

    }
    setRoute(routeType: string){
        localStorage.setItem('routeType', routeType);
        if(routeType == 'DigitalRoute'){}
        {
            this.isDigitalRoute = true;
        }
        if(routeType == 'TextRoute'){
            this.isDigitalRoute = false;
        }

    }
}
